import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { localStorageInstance } from "../../../utils/localStorage";
import { useLoginUser } from "../../../utils/reactQuery/users";
import { user } from "../../../redux/usersSlice";
import Worklog from "../Worklog";
import AllocationGrouping from "../Grouping/AllocationGrouping";
import { currentUserId } from "../../../utils/constants";
import MyTaskPage from "./MyTaskPage";

function TaskDetail() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const userId = currentUserId();
  const { data, isLoading } = useLoginUser(userId);
  const dispatch = useDispatch();

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  };

  if (data) {
    dispatch(user(data.data.data.responseData));
  }

  useEffect(() => {
    if (!tab) updateSearchParams("tab", "mine");
  }, []);
  return (
    <>
      {!isLoading && (
        <Box>
          {tab === "team" && <AllocationGrouping />}
          {tab === "mine" && (
            <>
              <MyTaskPage />
            </>
          )}
          {tab === "worklog" && (
            <>
              <Worklog />
            </>
          )}
        </Box>
      )}
    </>
  );
}

export default TaskDetail;
